import { client } from "api";

export type AddChildOrderRequest = { parentOrderId: string; childOrderId: string };
export type AddChildOrderResponse = void;

export const addChildOrder = ({ parentOrderId, childOrderId }: AddChildOrderRequest) =>
  client
    .post<AddChildOrderResponse>(`/order/${parentOrderId}/children/${childOrderId}`)
    .then((res) => res.data);
